import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getDatasetMembers, getMembers, getTabs } from "./selectors"
import withUrlParams from "hocs/withUrlParams"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: get(state, "global.selected.account"),
    datasetId: get(props, "params.datasetId"),
  }),
  required: ["account", "datasetId"],
  data: [{
    resource: "members",
    url: () => {
      return {
        id: "members",
        query: `query {
          members {
            id
            name
          }
        }`,
      }
    },
  },
  {
    resource: "datasetEntitlements",
    url: ({ account, datasetId }) => `/api/${account}/reports/entitlements/dataset/${datasetId}`,
  }],
  mapStateToProps: (state, props) => ({
    role: getRole(state),
    userId: get(state, "user.id"),
    datasetMembers: getDatasetMembers(state),
    members: getMembers(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
